export default __webpack_public_path__ + "static/media/dynamics.d30c5129.png";